import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class CardService {
  constructor(private api: ApiService) {}

  PATH = 'v1/card';

  getCard(card: string) {
    return this.api.get(`${this.PATH}/${card}`);
  }

  getCards(limit: number, page: number) {
    var query = `?limit=${limit}&page=${page}`;
    return this.api.get(`${this.PATH}/list` + query);
  }

  getStampEvents(
    limit: number,
    page: number,
    user?: string,
    customer?: string,
    points?: boolean
  ) {
    var query = `?limit=${limit}&page=${page}&user=${user}&customer=${customer}&points=${points}`;
    return this.api.get(`${this.PATH}/stamp-events` + query);
  }

  createCard(payload: any) {
    return this.api.post(`${this.PATH}`, payload);
  }

  editCard(payload: any) {
    return this.api.post(`${this.PATH}/edit`, payload);
  }

  toggleCard(payload: any) {
    return this.api.post(`${this.PATH}/toggle`, payload);
  }
}
